import { PATHS } from '@bo-constants/routes';
import { SimulationLinks } from '@bo-components/simulations/SimulationLinks';
import addIcon from '@library/assets/images/icons/add-white-icon.svg';
import refreshIcon from '@library/assets/images/icons/refresh-icon.svg';

export interface SimulationCTAProps {
  selectedGameId: string;
  selectedLeagueId?: string;
}

export const SimulationCTA = ({
  selectedGameId,
  selectedLeagueId = ''
}: SimulationCTAProps) => {
  return (
    <div className="px-8 py-4">
      <div className="bg-soFresh-110 flex w-full gap-4 rounded-sm px-6 py-4">
        <div className="bg-soFresh-120 flex w-full flex-col items-start gap-2 self-stretch rounded-md px-12 py-8 text-left">
          <h2 className="text-soClean-100 text-base font-semibold">
            What would you like to do?
          </h2>
          <span className="text-soClean-100 pt-2 text-sm">
            You can create a new simulation, or view, test, and rerun an
            existing one.
          </span>
          {selectedGameId === '' ? (
            <span className="text-soClean-100 py-2 text-sm">
              Select a game to get started.
            </span>
          ) : (
            <SimulationLinks
              primaryLink={`${PATHS.SIMULATIONS}/${selectedLeagueId}/${selectedGameId}`}
              primaryLinkChildren={
                <>
                  <img
                    className="size-4 shrink-0"
                    src={refreshIcon}
                    alt="View Existing Simulations"
                  />
                  <span className="pl-2">Existing Simulation</span>
                </>
              }
              secondaryLink={`${PATHS.SIMULATIONS}/${selectedLeagueId}/${selectedGameId}/NEW`}
              secondaryLinkChildren={
                <>
                  <img
                    className="size-4 shrink-0"
                    src={addIcon}
                    alt="Create a simulation"
                  />
                  <span className="pl-2">Create New Simulation</span>
                </>
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};
